import styled from 'styled-components'

import breakpoints from '../../../../theme/breakpoints'
import DeclarationFormLayout from '../../../../layouts/DeclarationFormLayout'
import ActionButton from '../../../ActionButton'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const FormLayout = styled(DeclarationFormLayout)`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0 1.6rem 3rem 1.6rem;

  ${breakpoints.up('desktop')} {
    padding: 0 0 4rem 0;
  }
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.H4}
  color: ${({ theme }) => theme.colors.nightRider};
  margin-bottom: 1.6rem;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.textLarge}
  color: ${({ theme }) => theme.colors.nightRider};
  margin: 0 0 4rem 0;
`

export const Button = styled(ActionButton)`
  width: max-content;
`
